global.baseUrl = "https://api.geoticket.it";


global.getFormData = function (object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => {
        // if (object[key] !== null)
        formData.append(key, object[key])
    });
    // console.log("formData")
    // console.log(formData)
    return formData;
};

let route = {
    permission: "/app/permission",

    areaListLevel: "/app/area/list/level",
    blogList: "/app/blog/list",
    blogInfo: "/app/blog/info",

};

for (let i in route) {
    route[i] = global.baseUrl + route[i];
}

global.route = route;
module.export = route;
